{
  "detailTypeIdentifier": "TRAVEL-INSURANCE",
  "tariffList": [
    {
      "scheme": "LN_ramcove zmluvy",
      "tariff": "1LN1",
      "rate": 1.1,
      "zone": "A"
    },
    {
      "scheme": "LN_ramcove zmluvy",
      "tariff": "2LN1",
      "rate": 2.2,
      "zone": "B"
    },
    {
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "tariff": "1SB1",
      "rate": 2.6,
      "zone": "A"
    },
    {
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "tariff": "2SB1",
      "rate": 4,
      "zone": "B"
    },
    {
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "tariff": "1OB",
      "rate": 3.3,
      "zone": "A"
    },
    {
      "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
      "tariff": "2OB",
      "rate": 5,
      "zone": "B"
    },
    {
      "scheme": "r\u00e1mcov\u00e9 zmluvy - BB",
      "tariff": "1B1",
      "rate": 1.5,
      "zone": "A"
    },
    {
      "scheme": "r\u00e1mcov\u00e9 zmluvy - BB",
      "tariff": "2BB1",
      "rate": 2.9,
      "zone": "B"
    }
  ]
}
